import { initLogger } from "@skypointcloud/logger/react";
import type { ReactPlugin } from "@skypointcloud/logger/react";

const result = initLogger({
  appName: "skyHire-client",
  environment: import.meta.env.MODE,
  appInsightsConnectionString: import.meta.env.VITE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
});

export const reactPlugin = result.reactPlugin as ReactPlugin | undefined;
